import { Play } from 'lucide-react';
import PropTypes from 'prop-types';
import React from 'react';

import styles from './MocaPrompt.module.scss';

const WatchLink = ({ reviewUrl, label = 'Watch in Mindy Review' }) => (
  <a href={reviewUrl} target="_blank" rel="noopener noreferrer" className={styles.watchLink}>
    <Play size={12} aria-hidden="true" />
    {label}
  </a>
);

WatchLink.propTypes = { reviewUrl: PropTypes.string.isRequired, label: PropTypes.string };

export default WatchLink;
